(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('fieldOfficerList', fieldOfficerList);

    fieldOfficerList.$inject = ['$resource'];

    function fieldOfficerList ($resource) {
        var resourceUrl =  'api/users/Field_Officer';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
